<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <!-- <Mlogin/> -->
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">期刊简介</div>
                  <div class="title_more2"><a href="/">首页</a>>期刊简介</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="jj_con">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;《{{$store.state.Name}}》(半月刊)，中国科技核心期刊（科技论文统计源期刊），创刊于1993年，原名《国外电子元器件》，主要介绍具有较高学术水平的、电子领域相关的理论、技术、方法的专业性技术期刊。主要栏目有：计算机技术应用、网络与通信工程、测控与仪器仪表、图像与多媒体技术、开发与应用、数字处理技术、嵌入式技术、消费类电子、汽车电子、集成电路应用、新特器件应用、电源技术与应用、信息安全、工业自动化、电力电子等。 24年来，《{{$store.state.Name}}》知识涵盖面广、影响力度大，以弘扬科技创新、扩展学术领域为契机，为科研事业传播知识、积累学术成果以及国家科技发展做出了诸多贡献。 　　《{{$store.state.Name}}》（半月刊）为国际大开，定价：15.00元/期，全年24期，360.00元/年；国内统一连续出版物号：CN61-1477/TN，国际标准连续出版物号：ISSN 1674-6236；国内邮发代号：52-142，国际发行代号：M2996。
                  </div>

                  <div class="clearfix"></div>
                </div>

              </div>
            </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        keywords:'',
        activeName: 'first'

      }
    },
    components: {},
    methods: {

    }
  }
</script>

<style scoped>

</style>
